import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { _className, Button, ComponentSync, genericNotificationAction, LL_H_C, LL_V_L, ModuleFE_RoutingV2, TS_AppTools, TS_NavLink } from '@nu-art/thunderstorm-frontend/index';
import './ATS_Permissions.scss';
import { ModuleFE_PermissionsAssert } from '../../modules/ModuleFE_PermissionsAssert.js';
import { ModuleFE_Account } from '@nu-art/user-account-frontend/index';
import { arrayIncludesAny, timeout } from '@nu-art/ts-common';
import { SessionKey_StrictMode_FE } from '../../consts.js';
import { ModuleFE_PermissionAccessLevel } from '../../_entity/permission-access-level/index.js';
import { ModuleFE_PermissionAPI } from '../../_entity/permission-api/index.js';
import { ModuleFE_PermissionProject } from '../../_entity/permission-project/index.js';
import { ModuleFE_PermissionDomain } from '../../_entity/permission-domain/index.js';
import { ModuleFE_PermissionGroup } from '../../_entity/permission-group/index.js';
import { ModuleFE_PermissionUser } from '../../_entity/permission-user/index.js';
import { Outlet } from 'react-router';
import { PermissionUsersEditor } from '../permission-editors/permission-users-editor.js';
import { PermissionProjectsEditor } from '../permission-editors/permission-project-editor/permission-projects-editor.js';
import { PermissionDomainsEditor } from '../permission-editors/permission-domains-editor.js';
import { PermissionGroupsEditor } from '../permission-editors/permission-groups-editor.js';
export class ATS_Permissions extends ComponentSync {
    static screen = {
        key: 'permissions-dev-page',
        name: 'Permissions',
        renderer: this,
        group: 'Permissions',
        modulesToAwait: [
            ModuleFE_PermissionAccessLevel,
            ModuleFE_PermissionAPI,
            ModuleFE_PermissionProject,
            ModuleFE_PermissionDomain,
            ModuleFE_PermissionGroup,
            ModuleFE_PermissionUser,
        ],
        children: [
            PermissionProjectsEditor.Route,
            PermissionDomainsEditor.Route,
            PermissionGroupsEditor.Route,
            PermissionUsersEditor.Route,
        ]
    };
    componentDidMount() {
        const routeKeys = [PermissionProjectsEditor.Route.key,
            PermissionDomainsEditor.Route.key,
            PermissionGroupsEditor.Route.key,
            PermissionUsersEditor.Route.key,
        ];
        if (!arrayIncludesAny(window.location.pathname.split('/'), routeKeys))
            ModuleFE_RoutingV2.goToRoute(PermissionProjectsEditor.Route);
    }
    //######################### Logic #########################
    toggleStrictMode = async () => {
        await genericNotificationAction(async (notification) => {
            this.setState({ creatingPermissions: true });
            await ModuleFE_PermissionsAssert.v1.toggleStrictMode({}).executeSync();
            await timeout(3000);
            await ModuleFE_Account._v1.refreshSession({}).executeSync();
        }, 'Toggling Strict Mode');
        this.setState({ creatingPermissions: false });
    };
    //######################### Render #########################
    render() {
        return _jsxs(LL_V_L, { id: 'dev-page__permissions', children: [_jsxs(LL_H_C, { className: "match_width flex__space-between", children: [TS_AppTools.renderPageHeader('Permissions Editor'), _jsx(LL_H_C, { children: _jsxs(Button, { variant: 'secondary', disabled: this.state.creatingPermissions, className: 'item-list__add-button', onClick: this.toggleStrictMode, children: [SessionKey_StrictMode_FE.get() ? 'Disable' : 'Enable', " Strict Mode"] }) })] }), _jsxs(LL_H_C, { className: 'links-container', children: [_jsx(TS_NavLink, { route: PermissionProjectsEditor.Route, ignoreClickOnSameRoute: true, className: ({ isActive }) => _className('link-button', isActive && 'selected'), children: "Project" }, PermissionProjectsEditor.Route.key), _jsx(TS_NavLink, { route: PermissionDomainsEditor.Route, ignoreClickOnSameRoute: true, className: ({ isActive }) => _className('link-button', isActive && 'selected'), children: "Domains" }, PermissionDomainsEditor.Route.key), _jsx(TS_NavLink, { route: PermissionGroupsEditor.Route, ignoreClickOnSameRoute: true, className: ({ isActive }) => _className('link-button', isActive && 'selected'), children: "Groups" }, PermissionGroupsEditor.Route.key), _jsx(TS_NavLink, { route: PermissionUsersEditor.Route, ignoreClickOnSameRoute: true, className: ({ isActive }) => _className('link-button', isActive && 'selected'), children: "Users" }, PermissionUsersEditor.Route.key)] }), _jsx(Outlet, {})] });
    }
}
//# sourceMappingURL=ATS_Permissions.js.map